/* Formato de fecha general */
export const FORMATO_FECHA = 'YYYY-MM-DD';

/* Formato de momento general */
export const FORMATO_MOMENTO = 'YYYY-MM-DD HH:mm';

/* Formato de fecha para material */
export const FORMATO_FECHA_MAT = {
  parse: { dateInput: FORMATO_FECHA },
  display: {
    dateInput: FORMATO_FECHA,
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

/* Formato de fecha para el pipe de date */
export const FORMATO_FECHA_PIPE = 'yyyy-MM-dd';

/* Formato de fecha para el pipe de date */
export const FORMATO_FECHA_PIPE_2 = 'EEEE, MMMM d, y';

/* Formato de fecha para el pipe de momento */
export const FORMATO_MOMENTO_PIPE = 'yyyy-MM-dd HH:mm';

/* Formato de fecha para el pipe de momento */
export const FORMATO_MOMENTO_PIPE_2 = 'EEE, MMM d, y - HH:mm';

/* Icono de la plataforma */
export enum Icono {
  // Verificaciones de identidad
  APROBACION = 'verified',

  // Órdenes
  ORDENES = 'receipt', // insert_drive_file // description
  CREAR_ORDEN = 'note_add',
  PREPARACION = 'shopping_bag', // 'shopping_basket'
  APLAZAR = 'more_time',
  MEDICAMENTO = 'medication',
  EXPRESS = 'cases', // 'bolt'
  RECOGIDAS = 'calendar_month',

  // Domicilios
  DOMICILIOS = 'house', // 'location_on'
  DESPACHO = 'local_shipping',
  ETIQUETAS = 'receipt_long', // 'sticky_note_2'
  RECOGIDA = 'move_to_inbox',
  ENRUTAMIENTO = 'route',
  ENVIO = 'local_shipping',
  ENTREGA = 'house',
  LEGALIZACION = 'gavel',
  REPROGRAMAR = 'event_repeat', // 'repartition'
  RETORNAR = 'assignment_return',
  RUTAS = 'airport_shuttle',

  // Paquetes
  PAQUETES = 'inventory',
  TRASLADOS = 'shopping_bag',

  // Planillas
  PLANILLA_RECOGIDA = 'assignment_turned_in',
  PLANILLA_RODAMIENTO = 'flip_camera_android',

  // Comunicaciones
  SMS = 'sms',
  ENVIAR_SMS = 'send',
  CORREO = 'email',
  ENVIAR_CORREO = 'outgoing_mail',

  // Clientes
  CLIENTES = 'group',
  VERIFICACIONES = 'fingerprint', // verified_user // how_to_reg
  PERFIL = 'person',

  // Reportes
  REPORTES = 'bar_chart',
  EN_VIVO = 'sensors',

  // Servicios
  ENCARGO = 'assignment',
  DIGITURNO = 'qr_code',
  RECOLECTAR = 'exit_to_app',

  // Rastreo
  MAPA = 'map',
  JORNADAS = 'hail',

  // Facturación
  CUENTA_COBRO = 'payments',

  // Caja
  CAJA = 'point_of_sale',

  // Trayectos
  TRAYECTOS = 'commute',

  // Campañas
  CAMPANAS = 'verified',

  // Acciones
  CREAR = 'add',
  VER = 'visibility',
  EDITAR = 'mode_edit',
  ELIMINAR = 'delete',
  GUARDAR = 'save',
  CANCELAR = 'cancel',
  REVERTIR = 'undo',
  AVISOS = 'notifications',
  WHATSAPP = 'chat',
  DESCARGAR = 'download',
  PDF = 'picture_as_pdf',
  SUBIR = 'upload',
  CERRAR = 'close',
  SIGUIENTE = 'arrow_forward',
  ANTERIOR = 'arrow_back',
  SUBIR_ARCHIVO = 'upload_file',
  VER_ARCHIVO = 'file_open',
  INICIAR = 'play_circle',
  PAUSAR = 'pause_circle',
  COMPLETAR = 'assignment_turned_in',
  PAGAR = 'attach_money',
  QUITAR_PAGO = 'money_off',
  ESCANEAR = 'qr_code_scanner',
  IMPRIMIR = 'print',
  BUSCAR = 'search',
  RECARGAR = 'refresh',

  // CRM
  TIQUETES = 'message',
  CHATS = 'forum',
  WHATSAPP_ASESORES = 'phonelink_setup',

  // Otros
  ERROR = 'warning_amber',
  EXITO = 'check_circle_outline',
  INFO = 'info_outline',
  TAREAS_DIA = 'today',
  FOTOS = 'photo_library',
  TIEMPO = 'access_time',
  FECHA = 'event',
}

/* Imágenes de la plataforma */
export enum Imagenes {
  // Órdenes
  ORDENES = 'ordenes',
  CREAR_ORDEN = 'crear_orden',
  PREPARACION = 'preparacion2',
  EXPRESS = 'express',
  RECOGIDAS = 'recogidas',

  // Domicilios
  DOMICILIOS = 'domicilios',
  DESPACHO = 'despacho',
  REPROGRAMAR = 'reprogramar',
  RUTAS = 'rutas',

  // Paquetes
  PAQUETES = 'paquetes',
  TRASLADOS = 'traslados',

  // Comunicaciones
  SMS = 'sms',

  // Clientes
  CLIENTES = 'clientes',
  VERIFICACIONES = 'verificaciones',
  PERFIL = 'clientes',

  // Planillas
  PLANILLA_RECOGIDA = 'planillas_recogida',
  PLANILLA_RETORNO = 'retorno',
  PLANILLA_RODAMIENTO = 'planillas_rodamiento',

  // Reportes
  REPORTES = 'reportes',

  // Servicios
  DIGITURNO = 'digiturnos',
  ENCARGOS = 'encargos',

  // Facturación
  CUENTAS_COBRO = 'ordenes',

  // Caja
  CAJA = 'caja',
  BILLETES = 'billetes',

  // Trayectos
  TRAYECTOS = 'rutas',

  // Campañas
  CAMPANAS = 'campanas',

  // Rastreo
  MAPA = 'mapa',
  JORNADAS = 'jornadas',

  // CRM
  TIQUETES = 'tiquetes',
  CHATS = 'chats',

  // Otros
  TAREAS_DIA = 'tareas_dia',
}

/* Tutorial para quitarle la contraseña a un PDF (la farmacia no puede abrir los protegidos) */
export const URL_TUTORIAL_PDF_CONTRASENA = 'https://elevamedical.com/blog/quitar-contrasena-pdf/';
